import '../lightgallery/jquery-lightgallery';
import '../lightgallery/jquery-lightgallery-additional';
import '../lightgallery/jquery-lightgallery-aside';
import '../lightgallery/jquery-lightgallery-custom-content';
import '../lightgallery/jquery-lightgallery-topside';
import '../msnt/msnt-lightslider';

import { cmpDialog } from '../cmp-dialog';
import { lloadDisqus, translate, executeAsync, initCoralComments, coralCommentsEdition, getJson } from '../utils/fn';
import { loadGallery } from './msnt-photo-gallery-helper';
import device from 'current-device';
import { type } from 'jquery';

export const msntPhotoThumbGallery = selector => {
  var selector = selector || '.msnt-photo-thumb-gallery';
  var $dataEdtn = $('body').data('edtn');
  var showDisqusButton = $('.show-disqus');
  var ifVisible = showDisqusButton.data('visible');
  var lloadDisqusEditions = ['ar', 'br', 'ev_ar'];
  $('.msnt-photo-thumb-gallery-main-photo-box').on('click', function(event) {
    event.preventDefault();

    let $target = $(this)
      .closest('.msnt-photo-thumb-gallery')
      .find('.msnt-photo-thumb-gallery-photos-list .lslide.active');

    $target.trigger('click');
  });

  $(selector + ' .msnt-photo-thumb-gallery-photos-list').lightSlider({
    pager: false,
    autoWidth: true,
    rtl: $('body').data('rtl'),
    slideMargin: 5,
    enableDrag: false,
    onSliderLoad: function($el) {
      if ($el.data('slider-hash')) {
        var fragment = document.location.hash.replace(/[^a-zA-Z_0-9-/#]/g, '');
        if (fragment) {
          var isFullSize = fragment.lastIndexOf('#full-size/');
          if (isFullSize !== -1) {
            fragment = fragment.substr(0, isFullSize);
            if (fragment === '') {
              history.replaceState(
                {},
                null,
                document.location.href.replace('#full-size/', '')
              );
              setTimeout(function() {
                $(selector)
                  .find('.msnt-photo-thumb-gallery-main-photo-box')
                  .trigger('click');
              }, 10);
            } else {
              history.replaceState(
                {},
                null,
                document.location.href.replace('#full-size/', '')
              );
            }
            isFullSize = true;
          } else {
            isFullSize = false;
          }
          // if (fragment) {
            var $currentSlide = $el.find('[data-hash="' + fragment + '"]');
            isFullSize = true;
            if ($currentSlide.length) {
              var $mainPhoto = $(selector).find(
                '.msnt-photo-thumb-gallery-main-photo-box'
              );
              var $mainPhotoImage = $mainPhoto.find('img');
              var src = $currentSlide.data('src');
              var href = $currentSlide.data('url');
              if ($mainPhoto.length && $mainPhotoImage.length && src && href) {
                $el.goToSlide($currentSlide.index());
                $mainPhoto.attr('href', href);
                $mainPhotoImage.attr('src', src);
              }
              if (isFullSize) {
                setTimeout(function() {
                  $currentSlide.trigger('click');
                }, 10);
              }
            } else {
              let loadPhotoId;
              let $galleryItemLast = $(
                '.msnt-photo-thumb-gallery-photos-list .lslide'
              ).last();
              let $gallery = $(
                '.msnt-photo-thumb-gallery-photos-list'
              ).first();
              let match = fragment.match(/#(\d+)_/);
              if (match && match[1]) {
                loadPhotoId = match[1];
              } else {
                  console.log("No such photo id!");
              }
              
              let photoIds = $gallery.data('photo-ids').split(',');
              if (photoIds.includes(loadPhotoId)) {
                $galleryItemLast.attr('data-load-photo-hash', loadPhotoId);
                setTimeout(function() {
                  $galleryItemLast.trigger('click');
                }, 10);
              } else {
                history.replaceState({}, null, document.location.href.replace(hash, ''));
              }
                
            }
          // }
        }
      }
    },
  });

  let hash = document.location.hash,
    $gallerys = $('.msnt-photo-thumb-gallery-photos-list'),
    $sectionImg;
  const commentsBlockToScroll = document.querySelector('#comments');
  if (hash && !$gallerys.data('slider-hash')) {
    let dataHash = hash.replace(/[^a-zA-Z_0-9-\/]/g, ''),
      arrayOfHash = dataHash.split('/'),
      galleryCollection = getGallerysCollection(
        $gallerys,
        arrayOfHash[1],
        null
      );
      if(dataHash == 'comments') {
        history.replaceState({}, null, document.location.href.replace(hash, ''));
        
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 0);
        var distanceToAnchor = $(hash).offset().top;
        var distanceToAnchorNew;
        var callTimes = 0;
        // console.log(distanceToAnchor);

        // $('html, body').animate({
        //   scrollTop: $(hash).offset().top - 80
        // }, 500);


        commentsBlockToScroll.scrollIntoView({ behavior: 'smooth' });
        const url = new URL(window.location.href);

        if (url.searchParams.has('commentsLogin')) {
          url.searchParams.delete('commentsLogin');
          const triggerCoralBtn = document.querySelector('.show-coral');
          triggerCoralBtn.click();

          window.history.replaceState(
            null,
            null,
            `${url.pathname}${url.search}${url.hash}`,
          );
        }

        const resizeObserver = new ResizeObserver((entries, observer) => {
          for(let entry of entries){
              if (callTimes < 8) {
                calcResizeTimes();
              } else {
                resizeObserver.unobserve(document.querySelector('#post_box'));
                resizeObserver.unobserve(document.querySelector('#container_3rd_party_service'));
              }
          }
        })
        
        resizeObserver.observe(document.querySelector('#post_box'));
        resizeObserver.observe(document.querySelector('#container_3rd_party_service'));
    
        function calcResizeTimes() {
          distanceToAnchorNew = $(hash).offset().top - 80;
    
          if(distanceToAnchor != distanceToAnchorNew) {
            // $('html, body').animate({
            //   scrollTop: distanceToAnchorNew
            // }, 500);
            commentsBlockToScroll.scrollIntoView({ behavior: 'smooth' });
          }
          callTimes++;
        }

        if (lloadDisqusEditions.includes($dataEdtn) && ifVisible) {
          lloadDisqus();
          showDisqusButton.data('visible', false);
          showDisqusButton.hide();
        }
      }

    history.replaceState({}, null, document.location.href.replace(hash, ''));

    if (!galleryCollection) return;

    let galleryId = galleryCollection.galleryId;

    if (galleryId == null) {
      let photoId = galleryCollection.photoIds;

      $sectionImg = $(
        'section[data-widget="image"][data-id="' + photoId + '"]'
      ).first();

      executeAsync(() => {
        $sectionImg.trigger('click');
      });
    }

    let $gallery = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"]'
      ).first(),
      $galleryItem = $gallery.find(
        '.lslide[data-entity-id="' + arrayOfHash[1] + '"]'
      ),
      $galleryItemFirst = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"] .lslide'
      ).first(),
      offsetTop;

      const hashParts = hash.split('#');
      const cleanedParts = hashParts.map(part => part.replace(/\//g, '')).filter(part => part !== '');
      const anchorImgDataId = cleanedParts[0] === 'null' ? cleanedParts[1] : cleanedParts[0];
      
      const imgAnchorElement = $('[data-id="' + anchorImgDataId + '"]');
      

    if (imgAnchorElement.length != 0) {
      offsetTop = imgAnchorElement.offset().top - 60;
    } else if ($gallery.length != 0) {
      offsetTop = $gallery.closest('.msnt-photo-thumb-gallery').offset().top;
    } else {
      offsetTop = $('#container_3rd_party_service').offset().top;
    }

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    $('html, body').animate(
      {
        scrollTop: offsetTop,
      },
      0
    );

    if ($gallery.length != 0) {
      $gallery.attr({
        'data-ampgalleryid': galleryId,
        'data-ampphotoid': arrayOfHash[1],
      });

      executeAsync(() => {
        let itemClick =
          $galleryItem.length != 0 ? $galleryItem : $galleryItemFirst;
        itemClick.trigger('click');
      });
    }
  }

  $('.lslide, section[data-widget="image"][data-id]').on('click', function(
    event
  ) {
    if(event.target.nodeName === "A") {
      return event.target.click();
    }
    event.preventDefault();
    window.successResponse = true;

    let $this = $(this);
    let photoId;
    let clossestPhotoLists = $this.closest(
      '.msnt-photo-thumb-gallery-photos-list'
    );
    if ($this.data('load-photo-hash')) {
      let farPhotoLoadParam = $this.data('load-photo-hash');
      photoId = farPhotoLoadParam;
    } else {
      photoId =
        clossestPhotoLists.data('ampphotoid') ||
        $this.data('id') ||
        $this.data('entity-id');
    }

      let typeGallery = clossestPhotoLists.data('type-gallery');
      let galleryCollection = getGallerysCollection(
        $gallerys,
        photoId,
        typeGallery
      ),
      api = 'api';

    if (!galleryCollection) return;

    let galleryId = galleryCollection.galleryId,
      indexOf = galleryCollection.indexOf,
      $galleryList = $(
        '.msnt-photo-thumb-gallery-photos-list[data-galleryid="' +
          galleryId +
          '"]'
      ).first(),
      onMobileOff = document.documentElement.clientWidth < 768 ? false : true,
      onMobileLandscapeOff = false;

      if (device.type == 'mobile' && device.orientation !== 'portrait') {
        onMobileLandscapeOff = false;
      } else {
        onMobileLandscapeOff = true;
      }

    if (photoId == 'aditational-photo') {
      let $childs = $this.parent().children();

      indexOf = $childs.index(this);

      $galleryList = $this.closest('.msnt-photo-thumb-gallery-photos-list');
      galleryId = $galleryList.data('galleryid');
    } else if (galleryId == undefined && !typeGallery) {
      api = 'api2';
      galleryId = photoId;
      $galleryList = $this;
    }

    let preloader = $('.preloader');

    if (preloader.length == 0 && galleryCollection.galleryId) {
      $this.append(`<div class="preloader responsive" style="display: none;">
      <div class="spinner_loader"></div>
      </div>`);
      $('.preloader').fadeIn('slow');
    }

    if (!window.successResponse) return;
    window.successResponse = false;

    let url;

    if (typeGallery) {
      url = `/buy/${typeGallery}/${galleryId}/photos/`;
    } else {
      url = `/photos/${api}/${galleryId}/`;
    }

    let langs = $('body').data().edtn,
            configAdditation = ['ra_us', 'of', 'ev_us', 'ev_it', 'ev_fr', 'ev_br', 'ac', 'ev_de', 'ev_tr', 'ev_ru', 'ot', 'ev_ar'],
            prefix = configAdditation.includes(langs) ? langs : 'us';

    (async () => {
      let data = await getJson(url),
          arrayPhotos = [],
          adIndex;
      
      const skipIndex = 5;
      const startIndex = device.type == 'mobile' ? 2 : 3;

      if ((data.photos.length == 1 && device.type == 'mobile') || data.status !== true ) {
        return;
      }

      if (preloader.length == 0) {
        $this.append(`<div class="preloader responsive" style="display: none;">
        <div class="spinner_loader"></div>
        </div>`);
        $('.preloader').fadeIn('slow');
      }

      $('.preloader').remove();

      for (let index = 0; index < data.photos.length; index++) {
        if ((index == startIndex || index == adIndex) && device.type == 'mobile' && data.ads_banner) {
          // unique ID's required to initialize banners with RelevantYield
          const srcWithUniqueId = data.ads_banner
            .replace(
              /id=(["'])(ads_[^"']+)\1/, 
              (_, quote, idVal) => `id=${quote}${idVal}_${index}${quote}`
            )
            .replace(
              /id="([^"]+)"/,
              (match, p1) => `id="${p1}_${index}"`
            );
            // .replace(
            //   /data-ad-unit-id="([^"]+)"/,
            //   (match, p1) => `data-ad-unit-id="${p1}_${index}"`
            // );
          // console.log(srcWithUniqueId);

          arrayPhotos.push({
            src: srcWithUniqueId,
            thumb: `/design/images/${prefix}_logo_gallery.svg`,
            adSlide: true
          });

          adIndex = index;
          adIndex += skipIndex;
        }

        let finalAuthorTitle = data.photos[index].author_title
              ? '(' +
                translate('photo_by', 'Photo by') +
                ' ' +
                data.photos[index].author_title +
                ')'
              : '';

        let subHtml = data.photos[index].title + ' ' + finalAuthorTitle;

        let sizeImg = onMobileOff
            ? data.photos[index].big
            : typeGallery && onMobileOff
            ? data.photos[index].large
            : data.photos[index].middle;

        arrayPhotos.push({
          src: sizeImg,
          thumb: typeGallery ? data.photos[index].middle : data.photos[index].small,
          caption: data.photos[index].caption || null,
          source: data.photos[index].source || null,
          sourceUrl: data.photos[index].source_url || null,
          title: data.photos[index].title || null,
          subHtml: data.car_title || subHtml,
          url: data.photos[index].url || null,
          entityId:data.photos[index].photo_edition_id || null,
          hor: data.photos[index].hor,
          description: data.photos[index].description,
          downloadUrl: data.photos[index].big,
          photoNumber: index,
          photoAnchorUrl: '#' + data.photos[index].photo_edition_id + '_' + data.photos[index].alias,
          parrentGalleryUrl: '/photos/' + data.photos[index].photo_gallery_edition_id + '/' + data.photos[index].photo_gallery_alias + '/'
        });
      }

      if ((api = 'api2')) {
        arrayPhotos.forEach((element, index) => {
          if (element.entityId == photoId) {
            indexOf = index;
          }
        });
      }   prefix = configAdditation.includes(langs) ? langs : 'us';

      if (data.additional_slide) {
        arrayPhotos.push({
          src: data.additional_slide,
          thumb: `/design/images/${prefix}_logo_gallery.svg`,
          htmlSlide: true,
        });
      }

      loadGallery({
        arrayPhotos: arrayPhotos,
        galleryId: galleryId,
        indexOf: indexOf,
        $galleryList: $galleryList,
        onMobileOff: onMobileOff,
        onMobileLandscapeOff: onMobileLandscapeOff,
        photosAmount: data.photos.length,
        additionalParams: {
          dynamicGallery: true,
        },
      });

    })().catch(err => {
      console.error(err);
      window.successResponse = true;
      return cmpDialog.content('Sorry service unavailable try again later');
    });
    // return;

    // $.get({
    //   url: url,
    //   success: function(data) {
    //     let arrayPhotos = [];

    //     $('.preloader').remove();

    //     if (!data.status) {
    //       window.successResponse = true;
    //       return cmpDialog.content('Sorry service unavailable try again later');
    //     }

    //     const skipIndex = 5;
    //     let adIndex;

    //     for (let index = 0; index < data.photos.length; index++) {
    //       if ((index == 3 || index == adIndex) && device.type == 'mobile' && data.ads_banner) {
    //         arrayPhotos.push({
    //           src: data.ads_banner,
    //           thumb: `/design/images/${prefix}_logo_gallery.svg`,
    //           adSlide: true
    //         });

    //         adIndex = index;
    //         adIndex += skipIndex;
    //       }

    //       let finalAuthorTitle = data.photos[index].author_title
    //         ? '(' +
    //           translate('photo_by', 'Photo by') +
    //           ' ' +
    //           data.photos[index].author_title +
    //           ')'
    //         : '';

    //       let subHtml = data.photos[index].title + ' ' + finalAuthorTitle;

    //       let sizeImg = onMobileOff
    //         ? data.photos[index].big
    //         : typeGallery && onMobileOff
    //         ? data.photos[index].large
    //         : data.photos[index].middle;

    //       arrayPhotos.push({
    //         src: sizeImg,
    //         thumb: typeGallery ? data.photos[index].middle : data.photos[index].small,
    //         caption: data.photos[index].caption || null,
    //         title: data.photos[index].title || null,
    //         subHtml: data.car_title || subHtml,
    //         url: data.photos[index].url || null,
    //         entityId:data.photos[index].photo_edition_id || null,
    //         hor: data.photos[index].hor,
    //         description: data.photos[index].description,
    //         downloadUrl: data.photos[index].big,
    //         photoNumber: index
    //       });
    //     }

    //     if ((api = 'api2')) {
    //       arrayPhotos.forEach((element, index) => {
    //         if (element.entityId == photoId) {
    //           indexOf = index;
    //         }
    //       });
    //     }   prefix = configAdditation.includes(langs) ? langs : 'us';

    //     if (data.additional_slide) {
    //       arrayPhotos.push({
    //         src: data.additional_slide,
    //         thumb: `/design/images/${prefix}_logo_gallery.svg`,
    //         htmlSlide: true,
    //       });
    //     }

    //     loadGallery({
    //       arrayPhotos: arrayPhotos,
    //       galleryId: galleryId,
    //       indexOf: indexOf,
    //       $galleryList: $galleryList,
    //       onMobileOff: onMobileOff,
    //       onMobileLandscapeOff: onMobileLandscapeOff,
    //       additionalParams: {
    //         dynamicGallery: true
    //       }
    //     });
    //   },
    // });
  });


  function getGallerysCollection($gallerys, photoId, typeGallery) {
    //if ($gallerys.length == 0 || ($gallerys.length == 1 && device.type == 'mobile')) return;

    let galleryCollection = [];

    $gallerys.each(function(indexGallery, elementGallery) {
      if (elementGallery.dataset.photoIds) {
        let photoIds = elementGallery.dataset.photoIds.split(',');

        photoIds.forEach((elementId, elementIndex) => {
          if (photoId == elementId) {
            galleryCollection.push({
              galleryId: elementGallery.dataset.galleryid,
              photoIds: elementId,
              indexOf: elementIndex,
            });
          }
        });
      } else if (typeGallery) {
        galleryCollection.push({
          galleryId: elementGallery.dataset.galleryid,
          typeGallery: typeGallery,
        });
      }
    });

    if (galleryCollection.length == 0) {
      galleryCollection = [
        {
          galleryId: null,
          photoIds: photoId,
        },
      ];
    }

    return galleryCollection[0];
  }
};
